var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"57ced25eb9eeb4ea57d9d2f6efd5406c0290bb06"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-react@farmec-sa"]={id:"57ced25eb9eeb4ea57d9d2f6efd5406c0290bb06"};
      